import React from 'react';

const WithPopCondition = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
) => {
  return (props: P) => {
    const showPopups = process.env.NEXT_PUBLIC_SHOW_POPUPS === 'true';

    if (!showPopups) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };
};

export default WithPopCondition;
